import { useCallback } from 'react';

import { useModal } from '@providers/ModalProvider';
import { ShareData } from '@components/modal/ShareModal';

export const useShareModal = () => {
  const { showShareModal } = useModal();

  const openShareModal = useCallback(
    (shareData: ShareData) => {
      showShareModal(shareData);
    },
    [showShareModal],
  );

  return {
    openShareModal,
  };
};
